import type { PlayerConfig } from './player.config';

import { useEffect } from 'react';

import { usePlayerOptions } from './hooks/use-player-options';
import { VideoJS } from './videojs';
import { LoggerProvider, useLogger } from '../../contexts/logger-context';
import { getPackageVersion } from '../../utils/version';

export function Player(props: PlayerConfig) {
  return (
    <LoggerProvider debug={props.debug}>
      <PlayerComponent {...props} />
    </LoggerProvider>
  );
}

function PlayerComponent(props: PlayerConfig) {
  const { logger } = useLogger();

  useEffect(() => {
    const playerVersion = getPackageVersion();

    logger.info(`Hello from Player (${playerVersion}) :D`);
    logger.info(
      'For more advanced logging options, you can set "miplayer::logFilters" in local storage to a JSON string.'
    );

    logger.info(
      'Example: Allow only categories "PlayerOptions", "SetSource", and "PlayerSource":',
      JSON.stringify({
        allowedCategories: ['PlayerOptions', 'SetSource', 'PlayerSource'],
        blockedCategories: [],
      })
    );

    logger.info(
      'Example: Allow category "PlayerSource" and "default":',
      JSON.stringify({
        allowedCategories: ['PlayerSource'],
        blockedCategories: [],
        showUnnamedLoggers: true,
      })
    );
  }, [logger]);

  useEffect(() => {
    logger.debug('Player config:', props);
  }, [props, logger]);

  const playerOptions = usePlayerOptions(props);

  return <VideoJS options={playerOptions} />;
}
